import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import AnimateHeight from 'react-animate-height'
import Sprite from '~components/Sprite'

class Dropdown extends Component {
  constructor () {
    super()

    this.state = {
      open: false
    }
  }

  toggleDropdown (e) {
    const open = this.state.open

    this.setState((state) => {
      return { open: !open }
    })
  }

  isOpen (e) {
    return this.state.open
  }

  render () {
    const height = this.isOpen() ? 'auto' : 0
    const toggle = this.isOpen() ? 'border-grey border-b' : ''

    return (
      <div aria-expanded={this.isOpen()} className={classNames('block rounded border-grey border', this.props.classNames)}>
        <button type="button" className={classNames('focus:outline-none w-full h-12 flex justify-between items-center px-4', toggle)} onClick={this.toggleDropdown.bind(this)}>
          {this.props.title}

          <span aria-hidden="true" className={classNames('w-3 h-2 block transform ease-in-out transition-transform duration-150 pointer-events-none', { 'rotate-180': this.isOpen() })}>
            <Sprite name="chevron" />
          </span>
        </button>

        {this.props.links &&
        <AnimateHeight duration={300} height={height}>
          <div className="p-4 w-full -my-2">
            {this.props.links.map((link, index) => (
              <div className="my-2" key={index}>
                <NavLink to={link.url} className="hover:underline block">
                  {link.title}
                </NavLink>
              </div>
            ))}
          </div>
        </AnimateHeight>}
      </div>
    )
  }
}

Dropdown.propTypes = {
  title: PropTypes.string,
  links: PropTypes.array,
  classNames: PropTypes.string
}

export default Dropdown
